<template>
  <div class="head">
    <div class="container">
      <div class="logo forbes">
        <a
          href="https://forbes.hu"
          title="Forbes"
        >
          <img
            src="../assets/img/forbes-logo.svg"
            alt="Forbes"
          >
        </a>
      </div>
      <div class="tamcont">
        Támogatói tartalom
      </div>
      <div class="socialcont">
        <a
          href="https://www.facebook.com/sharer/sharer.php?u=https%3A//forbes.hu/extra/a-tudatos-autohasznalatrol/"
          title="Megosztás a Facebookon"
          class="face"
        >
          <img
            src="../assets/img/facebook-icon.svg"
            alt="Facebook"
          >
        </a>
        <a
          href="https://www.instagram.com/forbeshungary/"
          title="Forbes az Instagramon"
          class="insta"
        >
          <img
            src="../assets/img/instagram-icon.svg"
            alt="Instagram"
          >
        </a>
        <a
          href="https://twitter.com/home?status=https%3A//forbes.hu/extra/a-tudatos-autohasznalatrol/"
          title="Megosztás a Twitteren"
          class="twitter"
        >
          <img
            src="../assets/img/twitter-icon.svg"
            alt="Twitter"
          >
        </a>
      </div>
      <div class="mobilemenu">
        <div
          class="opener"
          v-on:click="menu()"
        >
          <div class="bars">

          </div>
        </div>
        <div class="inner">
          <ul class="links">
            <li v-if="this.$route.name != 'home'">
              <router-link to="/">
                Vissza a nyitó oldalra
              </router-link>
            </li>
            <li>
              <router-link to="/a-tudatos-autohasznalatrol">
                A tudatos autóhasználatról
              </router-link>
            </li>
            <li>
              <router-link to="/az-innovacio-iranti-vonzalomrol">
                Az innováció iránti vonzalomról
              </router-link>
            </li>
            <li>
              <router-link to="/mercedes-eqc">
                A modellről
              </router-link>
            </li>
          </ul>
          <div class="socialmob">
            <a
              href="https://www.facebook.com/sharer/sharer.php?u=https%3A//forbes.hu/extra/a-tudatos-autohasznalatrol/"
              title="Megosztás a Facebookon"
              class="face"
            >
              <img
                src="../assets/img/facebook-icon-dark.svg"
                alt="Facebook"
              >
            </a>
            <a
              href="https://www.instagram.com/forbeshungary/"
              title="Forbes az Instagramon"
              class="insta"
            >
              <img
                src="../assets/img/instagram-icon-dark.svg"
                alt="Instagram"
              >
            </a>
            <a
              href="https://twitter.com/home?status=https%3A//forbes.hu/extra/a-tudatos-autohasznalatrol/"
              title="Megosztás a Twitteren"
              class="twitter"
            >
              <img
                src="../assets/img/twitter-icon-dark.svg"
                alt="Twitter"
              >
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeadComponent',
  props: {
  },
  methods: {
    menu() {
      document.querySelector('.mobilemenu .inner').classList.toggle('show');
      document.querySelector('.mobilemenu').classList.toggle('open');
    },
  },
  mounted() {
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        if (document.querySelector('.mobilemenu .inner').classList.contains('show')) {
          document.querySelector('.mobilemenu .inner').classList.remove('show');
        }
        if (document.querySelector('.mobilemenu').classList.contains('open')) {
          document.querySelector('.mobilemenu').classList.remove('open');
        }
      } else {
        if (document.querySelector('.mobilemenu .inner').classList.contains('show')) {
          document.querySelector('.mobilemenu .inner').classList.remove('show');
        }
        if (document.querySelector('.mobilemenu').classList.contains('open')) {
          document.querySelector('.mobilemenu').classList.remove('open');
        }
      }
    },
  },
};
</script>

<style scoped lang="css">
.head {
  border-bottom: 2px solid #fff;
}
.container {
  display: flex;
  height: 90px;
  align-items: center;
  justify-content: space-between;
}
.logo.forbes {
  margin-left: 40px;
}
.socialcont {
  margin-right: 40px;
}
.logo.forbes img {
  height: 26px;
}
.logo.vodafone img {
  height: 40px;
}
.social img {
  height: 25px;
}
.insta {
  margin: 0 10px;
}
.social a:hover img {
  transform: scale(1.2);
}
.mobilemenu {
  display: none;
}
.tamcont {
  font-size: 18px;
  text-transform: uppercase;
  text-align: center;
}
.socialcont img {
  height: 20px;
}
.insta {
  margin: 0 15px;
}
.socialcont a:hover img {
  transform: scale(1.2);
}
@media screen and (max-width: 767px) {
  .logo.forbes {
    margin-left: 0px;
  }
  .socialcont {
    display: none;
  }
  .mobilemenu {
    display: block;
  }
  .opener {
    position: relative;
    cursor: pointer;
    height: 35px;
    display: flex;
    align-items: center;
    cursor: pointer;
    background-color: transparent;
    -webkit-tap-highlight-color: transparent;
  }
  .opener:focus {
    outline: none;
  }
  .bars {
    background-color: #fff;
    width: 30px;
    height: 3px;
  }
  .bars:before,
  .bars:after {
    content: "";
    height: 3px;
    width: 30px;
    display: block;
    position: absolute;
    background-color: #fff;
  }
  .bars:before {
    top: 8px;
  }
  .bars:after {
    bottom: 8px;
  }
  .open .bars {
    background-color: transparent;
  }
  .open .bars:before {
    transform: rotate(-45deg) translate(-6px, 4px);
  }
  .open .bars:after {
    transform: rotate(45deg) translate(-7px, -5px);
  }
  .mobilemenu .inner {
    position: absolute;
    top: 90px;
    left: 0px;
    width: 100%;
    background-color: #fff;
    height: 0px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    z-index: 2;
  }
  .links,
  .socialmob {
    visibility: hidden;
    font-size: 0;
  }
  .mobilemenu .inner.show .links,
  .mobilemenu .inner.show .socialmob {
    visibility: visible;
    font-size: inherit;
  }
  .mobilemenu .inner.show {
    height: 240px;
    box-shadow: 0px 0px 10px 0px #0f111b;
    transition: all 1s;
  }
  .inner img {
    height: 25px;
  }
  .inner a:hover img {
    transform: scale(1.2);
  }
  .insta {
    margin: 0 30px;
  }
  .socialmob {
    flex-basis: 100%;
    text-align: center;
    margin-bottom: 20px;
  }
  .links {
    list-style: none;
    margin-block-start: 0;
    margin-block-end: 0;
    padding-inline-start: 0;
    margin: 20px 0;
  }
  .links,
  .links a {
    color: #000;
    text-decoration: none;
  }
  .links li {
    margin: 15px 0;
    text-align: center;
  }
}
</style>
